module.exports = __webpack_public_path__ + "static/media/Error.f873b109.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svgs/Error.svg
// module id = 173
// module chunks = 0